<div class="bg-night text-white max-h-[90vh] overflow-hidden flex flex-col min-w-[340px] sm:min-w-[440px]">
  <div class="p-4 lg:p-6 border-b border-white/10 flex items-center justify-between">
    <h2 class="text-xl lg:text-2xl font-bold flex items-center gap-3">
      <span class="material-symbols-outlined text-neon">local_bar</span>
      {{ product.name }}
    </h2>
    <button
      type="button"
      (click)="close()"
      class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="flex-1 overflow-y-auto p-4 lg:p-6 space-y-2">
    <p class="text-xs text-white/50 mb-3">{{ 'pos.drink_order.ingredients_label' | translate }}</p>

    @for (ingredient of ingredients(); track ingredient.ingredientId; let i = $index) {
      <div class="flex items-center justify-between gap-3 bg-white/5 rounded-xl px-4 py-3">
        <div class="flex-1 min-w-0">
          <p class="font-medium text-white truncate">{{ ingredient.ingredientName }}</p>
          <p class="text-xs text-white/40">
            {{ ingredient.unitPriceCents / 100 | number: '1.2-2' }} € /
            @if (ingredient.volumeMl != null) {
              {{ 'common.unit_ml' | translate }}
            } @else {
              {{ 'common.unit_pcs' | translate }}
            }
          </p>
        </div>

        <div class="flex items-center gap-2 shrink-0">
          <button
            type="button"
            (click)="adjustQty(i, -1)"
            [disabled]="ingredient.actualQty <= 0"
            class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 disabled:opacity-30 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
            data-testid="qty-decrease">
            <span class="material-symbols-outlined text-base">remove</span>
          </button>

          <span
            class="w-10 text-center font-bold"
            [class.text-neon]="ingredient.actualQty !== ingredient.defaultQty"
            [class.text-white]="ingredient.actualQty === ingredient.defaultQty"
            data-testid="qty-display">
            {{ ingredient.actualQty | number: '1.0-1' }}
          </span>

          <button
            type="button"
            (click)="adjustQty(i, 1)"
            class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center"
            data-testid="qty-increase">
            <span class="material-symbols-outlined text-base">add</span>
          </button>

          <span class="w-20 text-right text-sm font-semibold text-neon">
            {{ (ingredient.actualQty * ingredient.unitPriceCents) / 100 | number: '1.2-2' }} €
          </span>
        </div>
      </div>
    }

    @if (ingredients().length === 0) {
      <div class="text-center py-8 text-white/40">
        <span class="material-symbols-outlined text-4xl mb-2">science</span>
        <p>{{ 'pos.drink_order.no_ingredients' | translate }}</p>
      </div>
    }
  </div>

  <div class="p-4 lg:p-6 border-t border-white/10">
    <div class="flex items-center justify-between mb-4">
      <span class="text-white/70 text-lg">{{ 'pos.drink_order.total' | translate }}</span>
      <span
        class="text-3xl font-black text-neon"
        data-testid="total-price">
        {{ calculatedPrice() / 100 | number: '1.2-2' }} €
      </span>
    </div>

    <div class="flex gap-3">
      <button
        type="button"
        (click)="close()"
        class="flex-1 py-3 px-6 rounded-full border border-white/20 text-white font-medium hover:bg-white/10 transition-colors flex items-center justify-center gap-2">
        <span class="material-symbols-outlined">arrow_back</span>
        {{ 'pos.drink_order.cancel' | translate }}
      </button>

      <button
        type="button"
        (click)="confirm()"
        class="flex-1 py-3 px-6 rounded-full bg-neon text-night font-bold hover:bg-neon/80 transition-all flex items-center justify-center gap-2 uppercase"
        data-testid="confirm-button">
        <span class="material-symbols-outlined">check</span>
        {{ 'pos.drink_order.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
